<template>
  <!-- // condition on product in product listing in admin => filterby is_available
  // variant drop down in a given product => filterby is_saleable -->
  <div id='un_selection-container'>
    <nav id='un_itemnav' class='z_2'>
      <router-link class='cat_nav-header cur_p' tag='div' :to='{name: "gold-admin"}'>
        <h2><GrLogoLight class='admin_logo' /><span>Uncommon</span></h2>
      </router-link>

      <div class='un_menuitem_container' >
        <div class='detail_set'>
          <p>
            <span class='label'>Item</span>
            <span v-if='selectedVariant' class='value'>{{selectedVariant.product.item.type_of.name}}</span>
            <span v-else class='value'><MiniLoader/></span>
          </p>
        </div>
        <div class='detail_set'>
          <p>
            <span class='label'>Sku</span>
            <span v-if='selectedVariant' class='value'>{{selectedVariant.sku}}</span>
            <span v-else class='value'><MiniLoader/></span>
          </p>
        </div>
        <div class='detail_set'>
          <p>
            <span class='label'>Template</span>
            <span v-if='selectedVariant' class='value'>{{selectedVariant.product.decoration.name}}</span>
            <span v-else class='value'><MiniLoader/></span>
          </p>
        </div>
        <div class='detail_set'>
          <p>
            <span class='label'>Options</span>
            <AdminDropDownSelect
              v-if='variants'
              :options='variants'
              @selected='handleOptionSelected'
              :selectedItem='selectedItem'
              class='z_4' />
            <span v-else class='value'><MiniLoader/></span>
          </p>
        </div>
        <button class='publish-btn btn btn-primary mar_t_2 pad_05'>Publish</button>
      </div>
    </nav>

    <DesignProduct v-if='designerReady' />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import MiniLoader from '$shared/loaders/MiniLoader.vue'
import GrLogoLight from '$svgs/GrLogoLight.vue'
import AdminDropDownSelect from '@/components/gold-admin/AdminDropDownSelect.vue'
import DesignProduct from '@/components/product-designer/DesignProduct.vue'

export default {
  data () {
    return {
      template: null,
      item: null,
      variantSelection: null,
      designerReady: false,
      selectedItem: {
        name: 'Select an option'
      }
    }
  },
  computed: {
    ...mapState('system', ['variants', 'selectedDecoration', 'selectedVariant'])
  },
  watch: {
    $route: function (value) {
      if (value.params.variantId) {
        this.updateProductDesigner()
      }
    }
  },
  methods: {
    ...mapActions('system', ['getVariantsByProduct', 'getVariantById']),
    handleOptionSelected (selection) {
      /*
        1. Unmount the Product Designer
        2. update route with variant ID (only used in gold-env)
        2. Add required endpoints to the window object (simulate shopify JSON dump)
        3. Remount the Product Designer
      */
      this.variantSelection = selection
      this.selectedItem.name = selection.option.name

      let par = this.$route.params
      this.$router.push({
        name: 'designer-view-variant',
        params: {
          categoryId: par.categoryId,
          itemId: par.itemId,
          productId: par.productId,
          variantId: selection.id
        }
      })
    },
    updateProductDesigner () {
      this.designerReady = false
      window['gold_endpoints'] = {
        variantId: this.$route.params.variantId
      }
      setTimeout(() => {
        this.designerReady = true
      }, 500)
    }
  },
  mounted () {
    this.getVariantsByProduct({
      productId: this.$route.params.productId,
      cb: () => {
        this.getVariantById({
          variantId: this.$route.params.variantId ? this.$route.params.variantId : this.variants[0].id,
          cb: () => {
            if (this.$route.params.variantId) {
              this.selectedItem.name = this.selectedVariant.option.name
              this.updateProductDesigner()
            } else {
              this.handleOptionSelected(this.variants[0])
            }
          }
        })
      }
    })
  },
  components: {
    DesignProduct,
    MiniLoader,
    AdminDropDownSelect,
    GrLogoLight
  }
}
</script>
<style lang='scss' scoped>
#un_selection-container{
  @include full_wh;
  .detail_set{
    position: relative;
    border-bottom:1px solid #393a4a;
    padding:1.8rem 0rem;
    .label{
      display: block;
      text-transform: uppercase;
      color:#8c8c90;
      @include font-size(0.8);
    }
    .value{
      display: block;
      @include font-size(1.2);
      color:#E3E3E3;
      @include type_bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .publish-btn{
    position: relative;
    margin: 0 auto;
    display: block;
    width:80%;
    border:2px solid #E3E3E3;
    color:#E3E3E3;
    &:hover{
      border:2px solid $c_primarybtn_bg;
    }
  }
}
#un_itemnav{
  @include full_wh;
  position:fixed;
  width:$s_globalnav_w;
  padding-left: 2rem;
  padding-right: 2rem;
  overflow-y:scroll;
  background-color:$c_dark_blue;
  box-shadow: $shadow_gold-item-nav;
  .cat_nav-header{
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:5rem;
    padding:2rem;
    padding-top: 3rem;
  }
  h2{
    // color:#aaaaca;
    @include font-size(1.3);
    @include type_black;
    color: #E3E3E3;
    // text-transform: uppercase;
  }
  .admin_logo{
    width: 1.9rem;
    height: 1.7rem;
    display: inline-block;
    vertical-align: middle;
    margin-right: 1rem;
  }
  .un_menuitem_container{
    position: relative;
    margin-top: 10rem;
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/product-designer/DesignProductAdmin.vue